module.exports = __webpack_public_path__ + "img/edit.409b397c.svg";